import actionType from './actionType';
import initialState from './initialState';

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};


export default dashboardReducer;
